/* tslint:disable */
/* eslint-disable */
/**
 * Sds Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BumpItem
 */
export interface BumpItem {
    /**
     * 
     * @type {string}
     * @memberof BumpItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BumpItem
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BumpItem
     */
    shortText?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BumpItem
     */
    information?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BumpItem
     */
    campaignText?: string | null;
}

export function BumpItemFromJSON(json: any): BumpItem {
    return BumpItemFromJSONTyped(json, false);
}

export function BumpItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): BumpItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'shortText': !exists(json, 'shortText') ? undefined : json['shortText'],
        'information': !exists(json, 'information') ? undefined : json['information'],
        'campaignText': !exists(json, 'campaignText') ? undefined : json['campaignText'],
    };
}

export function BumpItemToJSON(value?: BumpItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'shortText': value.shortText,
        'information': value.information,
        'campaignText': value.campaignText,
    };
}


